"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactIconBase = _interopRequireDefault(require("react-icon-base"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var CategoryCodeCOMM = function CategoryCodeCOMM(props) {
  return _react.default.createElement(_reactIconBase.default, _extends({
    viewBox: "0 0 16 16"
  }, props), _react.default.createElement("g", null, _react.default.createElement("title", null, "CategoryCodeCOMM"), _react.default.createElement("g", {
    id: "shopping-cart"
  }, _react.default.createElement("g", {
    id: "Shape"
  }, _react.default.createElement("path", {
    d: "M6.652,12.336a.818.818,0,0,1-.247.595.8.8,0,0,1-1.168,0,.84.84,0,0,1,0-1.19.8.8,0,0,1,1.168,0A.818.818,0,0,1,6.652,12.336Zm5.816,0a.821.821,0,0,1-.246.595.8.8,0,0,1-1.169,0,.843.843,0,0,1,0-1.19.806.806,0,0,1,1.169,0A.821.821,0,0,1,12.468,12.336ZM13.3,5.141V8.527a.413.413,0,0,1-.107.281.408.408,0,0,1-.263.142l-6.777.807a4.188,4.188,0,0,1,.085.463,1.3,1.3,0,0,1-.156.423h5.972a.4.4,0,0,1,.292.126.421.421,0,0,1,0,.6.4.4,0,0,1-.292.126H5.406a.394.394,0,0,1-.292-.126.409.409,0,0,1-.124-.3.657.657,0,0,1,.052-.208,2.546,2.546,0,0,1,.1-.238c.035-.068.081-.157.14-.265s.092-.173.1-.2L4.237,4.717H2.913a.4.4,0,0,1-.292-.125.422.422,0,0,1,0-.6.4.4,0,0,1,.292-.125H4.575a.386.386,0,0,1,.185.043.374.374,0,0,1,.126.1.638.638,0,0,1,.085.162,1.107,1.107,0,0,1,.052.172c.008.047.02.112.035.2s.025.141.03.172h7.8a.4.4,0,0,1,.292.126A.412.412,0,0,1,13.3,5.141Z"
  })))));
};

var _default = CategoryCodeCOMM;
exports.default = _default;